import { officeOrderConstants } from "../actions/constants";

const initState = {
    orders: [],
    orderDetails: {},
    colorProducts: [],
    colorProductsLoading: false,
    counts: {},
    meta: {},
    total: 0,
    page: 1,
    limit: 0,
    mode: "office",

    loading: false,
    detailsLoading: false,
    createLoading: false,
    actionLoading: false,

    error: null,
    message: "",
    showAlert: false,
    variantAlert: "success",
    lastAction: "",
};

const getMessage = (payload, fallback = "") => {
    return payload?.message || payload?.error || fallback;
};

const getOrderFromPayload = (payload = {}) => {
    return payload.order || payload.orderDetails || payload.result || payload.orders || null;
};

const upsertOrder = (orders = [], order) => {
    if (!order?._id) return orders;

    const exists = orders.some((item) => String(item._id) === String(order._id));

    if (!exists) return [order, ...orders];

    return orders.map((item) => {
        return String(item._id) === String(order._id) ? order : item;
    });
};

const removeOrder = (orders = [], orderId) => {
    if (!orderId) return orders;

    return orders.filter((item) => String(item._id) !== String(orderId));
};

const shouldRemoveFromCurrentList = (order) => {
    if (!order?._id) return false;

    if (order.visibleOrder && order.visibleOrder.isCompleted === false) {
        return true;
    }

    return false;
};

export default function officeOrderReducer(state = initState, action) {
    switch (action.type) {
        case officeOrderConstants.OFFICE_ORDER_COLORS_REQUEST:
            return {
                ...state,
                colorProductsLoading: true,
                error: null,
            };

        case officeOrderConstants.OFFICE_ORDER_COLORS_SUCCESS:
            return {
                ...state,
                colorProductsLoading: false,
                colorProducts: action.payload?.colorProducts || [],
                error: null,
            };

        case officeOrderConstants.OFFICE_ORDER_COLORS_FAILURE:
            return {
                ...state,
                colorProductsLoading: false,
                error: action.payload?.error || action.payload?.message || "Ошибка загрузки цветов",
            };
        case officeOrderConstants.OFFICE_ORDER_SET_MODE:
            return {
                ...state,
                mode: action.payload || "office",
                orders: [],
                orderDetails: {},
                error: null,
                message: "",
                showAlert: false,
            };

        case officeOrderConstants.OFFICE_ORDER_CLOSE_ALERT:
            return {
                ...state,
                showAlert: false,
                message: "",
                error: null,
            };

        case officeOrderConstants.OFFICE_ORDER_LIST_REQUEST:
        case officeOrderConstants.OFFICE_ORDER_SEARCH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                showAlert: false,
                mode: action.meta?.mode || state.mode,
            };

        case officeOrderConstants.OFFICE_ORDER_DETAILS_REQUEST:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            };

        case officeOrderConstants.OFFICE_ORDER_CREATE_REQUEST:
            return {
                ...state,
                createLoading: true,
                loading: true,
                error: null,
                showAlert: false,
            };

        case officeOrderConstants.OFFICE_ORDER_MUTATION_REQUEST:
            return {
                ...state,
                actionLoading: true,
                error: null,
                showAlert: false,
            };

        case officeOrderConstants.OFFICE_ORDER_LIST_SUCCESS:
        case officeOrderConstants.OFFICE_ORDER_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                orders: action.payload?.orders || [],
                counts: action.payload?.counts || {},
                meta: action.payload?.meta || {},
                total: action.payload?.total || 0,
                page: action.payload?.page || 1,
                limit: action.payload?.limit || 0,
                mode: action.payload?.meta?.mode || state.mode,
                error: null,
                message: action.payload?.message || "",
            };

        case officeOrderConstants.OFFICE_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                orderDetails: action.payload?.order || {},
                error: null,
            };

        case officeOrderConstants.OFFICE_ORDER_CREATE_SUCCESS: {
            const order = getOrderFromPayload(action.payload);

            return {
                ...state,
                createLoading: false,
                loading: false,
                orders: order ? upsertOrder(state.orders, order) : state.orders,
                orderDetails: order || state.orderDetails,
                message: getMessage(action.payload, "Офисный заказ создан"),
                showAlert: true,
                variantAlert: "success",
                error: null,
                lastAction: "create",
            };
        }

        case officeOrderConstants.OFFICE_ORDER_MUTATION_SUCCESS: {
            const order = getOrderFromPayload(action.payload);

            const nextOrders = order
                ? shouldRemoveFromCurrentList(order)
                    ? removeOrder(state.orders, order._id)
                    : upsertOrder(state.orders, order)
                : state.orders;

            const isSameDetails = order && String(state.orderDetails?._id || "") === String(order._id);

            return {
                ...state,
                actionLoading: false,
                orders: nextOrders,
                orderDetails: isSameDetails ? order : state.orderDetails,
                message: getMessage(action.payload, "Заказ обновлён"),
                showAlert: true,
                variantAlert: "success",
                error: null,
                lastAction: "mutation",
            };
        }

        case officeOrderConstants.OFFICE_ORDER_LIST_FAILURE:
        case officeOrderConstants.OFFICE_ORDER_SEARCH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || action.payload?.message || "Ошибка",
                message: action.payload?.error || action.payload?.message || "Ошибка",
                showAlert: true,
                variantAlert: "warning",
            };

        case officeOrderConstants.OFFICE_ORDER_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                error: action.payload?.error || action.payload?.message || "Ошибка",
                message: action.payload?.error || action.payload?.message || "Ошибка",
                showAlert: true,
                variantAlert: "warning",
            };

        case officeOrderConstants.OFFICE_ORDER_CREATE_FAILURE:
            return {
                ...state,
                createLoading: false,
                loading: false,
                error: action.payload?.error || action.payload?.message || "Ошибка",
                message: action.payload?.error || action.payload?.message || "Ошибка",
                showAlert: true,
                variantAlert: "warning",
            };

        case officeOrderConstants.OFFICE_ORDER_MUTATION_FAILURE:
            return {
                ...state,
                actionLoading: false,
                error: action.payload?.error || action.payload?.message || "Ошибка",
                message: action.payload?.error || action.payload?.message || "Ошибка",
                showAlert: true,
                variantAlert: "warning",
            };

        default:
            return state;
    }
}